import { createSlice } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const initialState = {
  isBusinessAddressModalOpen: false,
  isReturnAddressModalOpen: false,
  isReturnAddressErrorShown: false,
  isUsingTheSameAddress: true,
  businessAddress: null,
  returnAddress: null
};

const toggleBusinessAddressModal = draft => {
  draft.isBusinessAddressModalOpen = !draft.isBusinessAddressModalOpen;
};

const toggleReturnAddressModal = draft => {
  draft.isReturnAddressModalOpen = !draft.isReturnAddressModalOpen;
};

const toggleUsingTheSameAddress = draft => {
  draft.isUsingTheSameAddress = !draft.isUsingTheSameAddress;
};

const setReturnAddressErrorShown = (draft, action) => {
  draft.isReturnAddressErrorShown = action.payload.isReturnAddressErrorShown;
};

const setBusinessAddress = (draft, action) => {
  draft.businessAddress = action.payload;
};

const setReturnAddress = (draft, action) => {
  draft.returnAddress = action.payload;
};

const fetchBusinessAddressesComplete = (draft, action) => {
  const {
    businessAddress,
    returnAddress,
    isUsingTheSameAddress
  } = action.payload;
  draft.businessAddress = businessAddress;
  draft.returnAddress = returnAddress;
  draft.isUsingTheSameAddress = isUsingTheSameAddress;
};

const businessAddressesSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    toggleBusinessAddressModal,
    toggleReturnAddressModal,
    toggleUsingTheSameAddress,
    setReturnAddressErrorShown,
    setBusinessAddress,
    setReturnAddress,
    fetchBusinessAddressesComplete
  }
});
export const {
  actions
} = businessAddressesSlice;
export const plug = {
  [stateName]: businessAddressesSlice.reducer
};
export default businessAddressesSlice.reducer;